module.exports = __webpack_public_path__ + "img/ico_weather_info.d0dcc81f.svg";